import React, { Component } from 'react'
import CategorySearch from '../../../components/classify-search'
import TableView from './table'
import {
    Divider,
} from 'antd';

export default class FuwuHallView extends Component {
    state = {
        queryParams: {
            classify: null,
            level: -1,
            province: null,             // 省
            city: null,                 // 市
            town: null,                 // 区
            search: null,               // search
            startTime: null,            // 发布时间范围：开始时间-今天
            endTime: null,              // 发布时间范围：开始时间-今天
        }
    }

    onChangeParams = (queryParams) => {
        this.setState({ queryParams: queryParams });
    }

    render() {
        const { queryParams } = this.state
            , { onChangeParams } = this
        return (
            <div className='container-display-center'>

                <CategorySearch
                    queryParams={queryParams}
                    onChangeParams={onChangeParams}
                />
                <Divider />

                <TableView
                    queryParams={queryParams}
                />

            </div>
        )
    }
}
